import axios from "axios";
import { axiosInstance } from "./AdminServices";

function resolvePublicApiBaseUrl() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname.toLowerCase();
    const isGaDomain =
      host === "graceanointing.org" ||
      host === "www.graceanointing.org" ||
      host === "stage.graceanointing.org" ||
      host === "stage.graceanoiinting.org";

    if (isGaDomain) {
      return `${window.location.origin}/api`;
    }
  }

  return process.env.REACT_APP_API_URL;
}

const API_URL = resolvePublicApiBaseUrl();
const PUBLIC_API_TOKEN =
  process.env.REACT_APP_PUBLIC_API_TOKEN || process.env.REACT_APP_GUEST_PASSWORD;
const PUBLIC_API_HEADERS = PUBLIC_API_TOKEN
  ? { "x-public-token": PUBLIC_API_TOKEN }
  : {};
const ACTIVE_EVENTS_CLIENT_CACHE_TTL_MS = Number(
  process.env.REACT_APP_ACTIVE_EVENTS_CACHE_TTL_MS || 120000
);

const activeEventsClientCache = {
  data: null,
  expiresAt: 0,
};

export async function getEvents(filters = {}) {
  const response = await axiosInstance.get("/event-master/events", {
    params: filters,
  });
  console.log("Fetched events:", response.data);
  return response.data;
}

export async function getPublicEvents(filters = {}) {
  const response = await axios.get(`${API_URL}/event-master/public/events`, {
    params: filters,
    headers: PUBLIC_API_HEADERS,
  });
  return response.data;
}

export async function getPublicActiveEvents(options = {}) {
  const forceRefresh = Boolean(options?.forceRefresh);
  const nowMs = Date.now();

  if (!forceRefresh && activeEventsClientCache.data && activeEventsClientCache.expiresAt > nowMs) {
    return activeEventsClientCache.data;
  }

  const response = await axios.get(`${API_URL}/event-master/public/events/active`, {
    headers: PUBLIC_API_HEADERS,
  });

  activeEventsClientCache.data = response.data;
  activeEventsClientCache.expiresAt = nowMs + ACTIVE_EVENTS_CLIENT_CACHE_TTL_MS;
  return response.data;
}


export async function getEventById(eventID) {
  const response = await axiosInstance.get(`/event-master/events/${eventID}`);
  return response.data;
}

export async function getEventSummary(eventID) {
  const response = await axiosInstance.get(
    `/event-master/events/${eventID}/summary`
  );
  return response.data;
}

export async function createEvent(payload) {
  const response = await axiosInstance.post("/event-master/events", payload);
  return response.data;
}

export async function updateEvent(eventID, payload) {
  const response = await axiosInstance.put(
    `/event-master/events/${eventID}`,
    payload
  );
  return response.data;
}

export async function deleteEvent(eventID) {
  const response = await axiosInstance.delete(`/event-master/events/${eventID}`);
  return response.data;
}

export async function uploadEventBrochure(eventID, file) {
  const formData = new FormData();
  formData.append("brochure", file);
  const response = await axiosInstance.post(
    `/event-master/events/${eventID}/brochure`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export async function getEventRegistrationIds(eventID, gender = "all") {
  const response = await axiosInstance.get(
    `/event-master/events/${eventID}/registration-ids`,
    {
      params: { gender },
    }
  );
  return response.data;
}

export function getBrochureUrl(eventID) {
  return `${API_URL}/event-master/brochure/${eventID}`;
}

export function buildGuestRegistrationLink(eventID) {
  const origin = window.location.origin;
  const base = process.env.REACT_APP_BASENAME || "";
  const normalizedBase = base.endsWith("/") ? base.slice(0, -1) : base;
  return `${origin}${normalizedBase}/retreat-registration?id=${eventID}`;
}

export function buildSpecialEventRegistrationLink(eventID, email, authCode) {
  const origin = window.location.origin;
  const base = process.env.REACT_APP_BASENAME || "";
  const normalizedBase = base.endsWith("/") ? base.slice(0, -1) : base;
  const params = new URLSearchParams({
    id: String(eventID || ""),
    email: String(email || ""),
    authCode: String(authCode || ""),
  });
  return `${origin}${normalizedBase}/retreat-registration?${params.toString()}`;
}

export async function validatePublicSpecialEventBooking(authCode, eventID, email) {
  const response = await axios.get(
    `${API_URL}/event-master/public/special-event-bookings/validate`,
    {
      params: { authCode, eventID, email },
      headers: PUBLIC_API_HEADERS,
    }
  );
  return response.data;
}

export async function uploadSpecialEventBookingsXls(eventCode, file, eventType = "Leaders") {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("eventCode", String(eventCode || ""));
  formData.append("eventType", String(eventType || "Leaders"));

  const response = await axiosInstance.post(
    "/event-master/special-event-bookings/upload",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export function buildQrImageUrl(value) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=320x320&data=${encodeURIComponent(
    value
  )}`;
}
